import {
  LuChevronRight,
  LuChevronLeft,
  LuEye,
  LuCircleArrowOutUpRight,
} from "react-icons/lu";
import { Link as RouterLink } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import ImageModal from "../Modal/ImageModal";
import projects from "../../data/projects";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation } from "swiper/modules";
import { useState } from "react";

export default function TabHtml() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedALt] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  return (
    <div className="tab-content ">
      <Swiper
        key={projects.html.id}
        modules={[Navigation]}
        navigation={{
          nextEl: ".custom-next",
          prevEl: ".custom-prev",
        }}
        spaceBetween={30}
        breakpoints={{
          0: {
            slidesPerView: 1,
          },
          800: {
            slidesPerView: 1,
          },
          1024: {
            slidesPerView: 2,
          },
        }}
        loop={true}
      >
        {projects.html.map((project) => (
          <SwiperSlide>
            <div className="tab-content__item">
              <div className="tab-content__head">
                <img
                  src={project.image}
                  alt={project.title}
                  className="tab-content__image"
                />
                <div className="tab-content__item__action">
                  {project.flag ? (
                    <RouterLink
                      className="tab-content__item__action-preview"
                      to={`${project.path}`}
                      target="_blank"
                    >
                      <LuEye />
                      <span>live preview</span>
                    </RouterLink>
                  ) : (
                    <RouterLink
                      className="tab-content__item__action-preview"
                      to={`/preview/html/${project.id}`}
                    >
                      <LuEye />
                      <span>live preview</span>
                    </RouterLink>
                  )}
                </div>
              </div>
              <div className="tab-content__holder">
                <div className="tab-content__info">
                  <RouterLink to={`/project/html/${project.id}`}>
                    <h2>{project.title}</h2>
                  </RouterLink>
                  <p>{project.description}</p>
                </div>
                <div className="tab-content__bottom">
                  <div className="tab-content__tags">
                    {project.tags.map((tag, index) => (
                      <span key={index}>{tag}</span>
                    ))}
                  </div>
                  <div className="tab-content__buttons">
                    <RouterLink to={`/project/html/${project.id}`}>
                      <LuCircleArrowOutUpRight />
                    </RouterLink>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="swiper-arrows">
        <button className="custom-prev">
          <LuChevronLeft />
        </button>
        <button className="custom-next">
          <LuChevronRight />
        </button>
      </div>
      <ImageModal
        visibility={`modal-control ${modalOpen && "modal-control--active"}`}
        imageSrc={selectedImage}
        imageAlt={selectedALt}
        onClose={() => {
          setModalOpen(false);
          setTimeout(() => {
            setSelectedImage(null);
          }, 600);
        }}
      />
    </div>
  );
}
